import * as React from 'react';
import * as classes from '@common/components/toast/toast.scss';
import 'react-toastify/dist/ReactToastify.css';

export enum ToastType {
  Success,
  Error,
  Warning,
  Info
}

interface ToastOption {
  className: string;
  bodyClassName: string;
  autoClose?: number;
}

interface ToastOptions {
  Success: ToastOption;
  Error: ToastOption;
  Warning: ToastOption;
  Info: ToastOption;
}

export const ToastOptions: ToastOptions = {
  Success: {
    className: 'toast-success',
    bodyClassName: 'toast-success'
  },
  Error: {
    className: 'toast-error',
    bodyClassName: 'toast-error',
    autoClose: 8000
  },
  Warning: {
    className: 'toast-warning',
    bodyClassName: 'toast-warning',
    autoClose: 8000
  },
  Info: {
    className: 'toast-info',
    bodyClassName: 'toast-info'
  }
};

interface ToastComponentProperties {
  type: ToastType;
  message: string;
}

export class ToastComponent extends React.Component<ToastComponentProperties> {
  renderIcon(type: ToastType) {
    switch (type) {
      case ToastType.Success:
        return <i className="fa fa-fw fa-check" />;
      case ToastType.Error:
        return <i className="fa fa-fw fa-exclamation-circle" />;
      case ToastType.Warning:
        return <i className="fa fa-fw fa-exclamation-triangle" />;
      case ToastType.Info:
        return <i className="fa fa-fw fa-info" />;
      default:
        return '';
    }
  }

  render() {
    return (
      <div className={[classes.toast, classes[ToastType[this.props.type]]].join(' ')}>
        <h3>
          {this.renderIcon(this.props.type)} {ToastType[this.props.type]}
        </h3>
        <p>{this.props.message}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/toast/toast.tsx